<template>
  <div
    id="vehicleDashboard-template-setting-window"
    class="template-setting-window"
    style="display: flex"
  >
    <div class="template-setting-window-header">
      <div class="template-setting-window-header-name">
        <strong>Работа ТС</strong><br />
        <small>Настройка отчета</small>
      </div>
      <!-- Картинка крестика-->
      <img
        class="close"
        src="/images/close.png"
        @click="closeHandler"
      />
    </div>

    <div class="overflow-auto">
      <table class="unselectable">
        <tr>
          <td><label for="groupByy">Период выборки:</label></td>
          <td>
            <select id="groupByy" v-model="groupBy" class="form-control-sm">
              <option value="day">Дням</option>
              <option value="week">Неделям</option>
              <option value="month">Месяцам</option>
              <option value="quarter">Кварталам</option>
            </select>
          </td>
        </tr>
      </table>
    </div>
    <div class="text-center">
      <span
        class="target-show"
        @mouseenter="(e) => addHoverOnTargetByParent(e)"
        @mouseleave="(e) => removeHoverOnTargetByParent(e)"
      >
        <input
          type="button"
          class="btn btn-primary config-btn-primary btn-sm"
          id="vehicleDashboard-template-setting-window-get-template-button"
          value="Выполнить отчет"
          @click="renderReport"
        />
        <span class="target-show-span">Обсчет данных для получения отчета</span>
      </span>
    </div>
  </div>
</template>

<script setup>
import { vehicleDashboard_template } from '../../../Template/vehicleDashboard/vehicleDashboard_template';
import { onMounted, ref } from 'vue';

import {
  addHoverOnTargetByParent,
  removeHoverOnTargetByParent,
} from '@/App/helpers/targetsHelper';

const props = defineProps({
  form_desc: { type: Object, require: true },
  areaId: { type: String, required: true },
});

const emit = defineEmits(['displayReport', 'close']);

const groupBy = ref('day'); // Значение по умолчанию


const renderReport = () => {
  const beginTime = +props.form_desc['beginTime'];
  const endTime = +props.form_desc['endTime'];
  let button = document.getElementById(
    'vehicleDashboard-template-setting-window-get-template-button',
  );
  let targetSpan = getNeighborByClass_helper(button, 'target-show-span');
  const SUMM_AREA_ID = 'section-reports';

  if (endTime <= beginTime) {
    infoShowText_helper(targetSpan, 'Конечная дата должна быть позже начальной', SUMM_AREA_ID);
    setElementColor_helper(button, 'orange');
    return;
  }
  if (groupBy.value === 'day') {
    // максимум 7 дней
    const maxRange = 7 * 24 * 60 * 60 * 1000;
    if (endTime - beginTime > maxRange) {
      infoShowText_helper(targetSpan, 'Для типа "Дням" промежуток времени не должен быть больше недели', SUMM_AREA_ID);
      setElementColor_helper(button, 'orange');
      return
    }
  } else if (groupBy.value === 'week') {
    // максимум 49 дней
    const maxRange = 7 * 7 * 24 * 60 * 60 * 1000;
    if (endTime - beginTime > maxRange) {
      infoShowText_helper(targetSpan, 'Для типа "Неделям" промежуток времени не должен быть больше 49 дней', SUMM_AREA_ID);
      setElementColor_helper(button, 'orange');
      return
    }
  } else if (groupBy.value === 'month') {
    // максимум 12 месяцев
    const maxRange = 12 * 30 * 24 * 60 * 60 * 1000;
    if (endTime - beginTime > maxRange) {
      infoShowText_helper(targetSpan, 'Для типа "Месяцам" промежуток времени не должен быть больше 12 месяцев', SUMM_AREA_ID);
      setElementColor_helper(button, 'orange');
      return
    }
  } else if (groupBy.value === 'quarter') {
    // максимум 4 квартала
    const maxRange = 4 * 3 * 30 * 24 * 60 * 60 * 1000;
    if (endTime - beginTime > maxRange) {
      infoShowText_helper(targetSpan, 'Для типа "Кварталам" промежуток времени не должен быть больше 4 кварталов', SUMM_AREA_ID);
      setElementColor_helper(button, 'orange');
      return
    }
  }

  const state = vehicleDashboard_template.submit(props.form_desc, groupBy.value, callback);
  if (state === 'error') {
    return;
  }

  closeHandler();
};

const callback = (data) => {
    data = data.map((obj) => ({ ...obj, data: JSON.parse(obj.data) }));
    emit('displayReport', { data, areaId: props.areaId });
};

const closeHandler = () => {
  document.getElementById('background-wrap').style.display = 'none';
  emit('close', 'vehicleDashboardTemplateSettings');
};
</script>

<style></style>
